export default __webpack_public_path__ + "static/dodgers-7a03952aa5c63f9462222b025457abdd.png";